export const getlocalStorageValueWithKey = (key: string): any | false => {
  try {
    const result = localStorage.getItem(key);
    return result ? JSON.parse(result) : false;
  } catch (error) {
    console.error("Error in getlocalStorageValueWithKey:", error);
    return false;
  }
};

export const setlocalStorageValueWithKey = (key: string, item: any): void => {
  try {
    localStorage.setItem(key, JSON.stringify(item));
  } catch (error) {
    console.error("Error in setlocalStorageValueWithKey:", error);
  }
};

export const clearlocalStorageKey = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error in clearlocalStorageKey:", error);
  }
};

// User Token Info
export const saveAccessTokenInfo = (tokenInfo: string): void => {
  try {
    sessionStorage.setItem("accessToken", tokenInfo);
  } catch (error) {
    console.error("Error in saveAccessTokenInfo:", error);
  }
};

export const clearAccessTokenInfo = (): void => {
  try {
    sessionStorage.removeItem("accessToken");
  } catch (error) {
    console.error("Error in clearAccessTokenInfo:", error);
  }
};

export const getAccessTokenInfo = () => {
  const token = sessionStorage.getItem("accessToken");
  if (!token) return {};
  try {
    return token; // decode JWT payload
  } catch {
    return {};
  }
};

// User Token Info
export const saveRefreshTokenInfo = (tokenInfo: string): void => {
  try {
    sessionStorage.setItem(
      "user_refresh_token_object",
      JSON.stringify(tokenInfo)
    );
  } catch (error) {
    console.error("Error in saveRefreshTokenInfo:", error);
  }
};

export const clearRefreshTokenInfo = (): void => {
  try {
    sessionStorage.removeItem("user_refresh_token_object");
  } catch (error) {
    console.error("Error in clearRefreshTokenInfo:", error);
  }
};

export const getRefreshTokenInfo = async (): Promise<any> => {
  try {
    const storedValue:any = sessionStorage.getItem("user_refresh_token_object");
    return storedValue !== undefined ? JSON.parse(storedValue) : false;
  } catch (error) {
    console.error("Error in getRefreshTokenInfo:", error);
    throw error; // Rethrow the error to be caught by the caller
  }
};
